import styles from './StatStrip.module.css';

export type Stat = {
  label: string;
  value: number | string;
  /** A status token name (`success`, `warning`, `faint`). */
  tone?: 'success' | 'warning' | 'danger' | 'faint';
};

/**
 * The compact metric row that sits above a list.
 *
 * Counts only. Anything that needs a chart belongs on the dashboard.
 */
export function StatStrip({ items }: { items: Stat[] }) {
  return (
    <dl className={styles.strip}>
      {items.map((item) => (
        <div key={item.label} className={styles.item}>
          {item.tone ? (
            <span
              className={styles.dot}
              style={{ background: `var(--${item.tone})` }}
              aria-hidden="true"
            />
          ) : null}
          <dt className={styles.label}>{item.label}</dt>
          <dd className={styles.value}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
